module.exports = __webpack_public_path__ + "static/smallFeature-f1b2bc92bccae3521560c15ef266d020.png";